var _style, _g, _feBlend, _feBlend2, _path, _path2, _path3, _path4, _g2, _g3, _g4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocusyncLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0C0C0C;}\n\t.st1{filter:url(#Adobe_OpacityMaskFilter);}\n\t.st2{filter:url(#Adobe_OpacityMaskFilter_00000016774251512615565800000005266211231896175551_);}\n\t.st3{mask:url(#SVGID_1_);fill:url(#SVGID_00000052092023584507883870000000315780312485816208_);}\n\t.st4{opacity:0.46;fill:url(#SVGID_00000167367858231865693270000012542793243417501824_);}\n\t.st5{fill:#1A1A1A;}\n\t.st6{fill:url(#SVGID_00000049183326545591924350000000814104283011442596_);}\n\t.st7{opacity:0.3;fill:#141414;}\n\t.st8{fill:url(#XMLID_00000118395325098288468080000009997332253094948740_);}\n\t.st9{fill:url(#XMLID_00000157266388499898592080000006971796652293130117_);}\n\t.st10{fill:#FFFFFF;}\n\t.st11{fill:#D6D6D6;}\n\t.st12{fill:#E79024;}\n\t.st13{opacity:0.8;}\n\t.st14{fill:#FFFEF6;}\n\t.st15{fill:url(#SVGID_00000003806307580071544000000005240587836304470198_);}\n\t.st16{fill:url(#SVGID_00000065789036816443705380000016437019666051607178_);}\n\t.st17{fill:url(#SVGID_00000079487609631490862780000012698969462385153159_);}\n\t.st18{fill:url(#SVGID_00000054251574160384511340000000055690345129004987_);}\n\t.st19{fill:url(#SVGID_00000145020574051657073710000012250061212346847398_);}\n\t.st20{fill:#ED2224;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M361.6,787.4c-1.1,3.4-2.5,6.3-4.4,8.7c-1.8,2.4-4,4.5-6.4,6.1c-2.4,1.6-5,2.9-7.8,3.8c-2.7,1-5.6,1.6-8.5,2 c-2.9,0.4-5.7,0.6-8.5,0.6h-32.6v-0.9c1.5-0.2,2.9-0.6,4.3-1.2c1.4-0.6,2.5-1.3,3.2-2.1c0.3-0.3,0.5-0.8,0.7-1.5 c0.1-0.7,0.3-1.5,0.4-2.4c0.1-0.9,0.2-1.8,0.3-2.9c0.1-1,0.1-2,0.1-2.9c0-0.8,0-2,0-3.4c0-1.4,0.1-3,0.1-4.7c0-1.7,0-3.4,0-5.2 c0-1.8,0-3.6,0-5.2v-17.4c0-1.1,0-2.1,0-3.2s0-2.1-0.1-3c-0.1-0.9-0.2-1.8-0.4-2.5c-0.2-0.7-0.4-1.3-0.8-1.7 c-0.9-1.1-2-1.8-3.2-2.2c-1.2-0.4-2.6-0.7-4.2-0.9v-0.9c2.5,0,6.1,0,10.8,0c4.7,0,10.4,0,17,0c1.9,0,3.8,0,5.7,0 c2,0,3.9,0.1,5.9,0.3c2,0.2,3.9,0.5,5.9,0.9c2,0.4,3.9,1,5.8,1.9c2.5,1.1,4.8,2.4,7,4.1s4.1,3.6,5.8,5.9c1.6,2.3,2.9,4.9,3.9,7.9 c1,3,1.5,6.4,1.5,10.3C363.2,780.1,362.7,784,361.6,787.4z M350.6,765.7c-1.1-3.3-2.6-6.2-4.5-8.9c-1.9-2.6-4.2-4.9-6.8-6.7 c-2.6-1.8-5.5-3-8.6-3.6c-1.2-0.2-2.5-0.4-3.9-0.6c-1.4-0.1-3.2-0.2-5.3-0.2c-0.7,0-1.5,0-2.3,0c-0.8,0-1.7,0.1-2.5,0.2 c-0.8,0.1-1.5,0.2-2.2,0.2c-0.7,0.1-1.2,0.1-1.7,0.3c-0.3,2.9-0.5,6.9-0.5,12c-0.1,5.1-0.1,11.2-0.1,18.3c0,3.8,0,7.3,0,10.4 c0,3.1,0,5.6,0.1,7.6c0,0.8,0,1.7,0.1,2.7s0.2,1.9,0.3,2.9c0.1,0.9,0.3,1.8,0.6,2.5c0.3,0.7,0.6,1.3,0.9,1.7 c1.2,1.2,2.7,1.9,4.5,2.3c1.8,0.3,3.5,0.5,5.1,0.5c1.5,0,3-0.1,4.6-0.2c1.6-0.1,3-0.4,4.4-0.8c6.4-1.8,11.2-5.4,14.4-10.8 c3.2-5.3,4.8-11.9,4.8-19.7C352.2,772.3,351.7,769,350.6,765.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.7,795.1c-1.2,2.8-2.9,5.3-5.1,7.4c-2.1,2.1-4.6,3.7-7.5,4.8s-5.9,1.7-9.1,1.7c-3.2,0-6.2-0.6-9-1.7 c-2.8-1.1-5.3-2.7-7.4-4.7c-2.1-2-3.8-4.4-5-7.2c-1.2-2.8-1.8-5.9-1.8-9.3c0-3.6,0.6-6.8,1.9-9.6c1.3-2.9,3-5.3,5.2-7.2 s4.7-3.5,7.7-4.6c2.9-1.1,6-1.6,9.3-1.6c3.5,0,6.7,0.6,9.5,1.9c2.8,1.2,5.2,2.9,7.2,5c2,2.1,3.5,4.5,4.5,7.3 c1,2.7,1.6,5.6,1.6,8.6C413.6,789.1,413,792.2,411.7,795.1z M404.9,778.2c-0.6-2.6-1.6-4.9-2.9-7c-1.3-2.1-2.9-3.8-4.9-5.1 c-2-1.3-4.3-2-6.9-2c-2.7,0-5,0.7-7,2c-2,1.3-3.6,3-4.9,5.1c-1.3,2.1-2.2,4.4-2.8,7.1s-0.9,5.3-0.9,8c0,2.8,0.3,5.6,1,8.2 c0.7,2.6,1.7,4.9,3,6.9c1.3,2,3,3.6,4.9,4.8c2,1.2,4.3,1.8,6.9,1.8s4.9-0.7,6.8-2c1.9-1.3,3.5-3,4.8-5.2c1.3-2.1,2.3-4.5,2.9-7.1 s1-5.2,1-7.9C405.9,783.3,405.5,780.8,404.9,778.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M459.5,778.1c-0.5-2-1.4-3.9-2.4-5.6c-1.1-1.7-2.4-3.3-3.8-4.6c-1.5-1.3-3.1-2.3-5-3.1 c-1.9-0.7-3.8-1.1-5.9-1.1c-2.9,0-5.4,0.6-7.7,1.9c-2.2,1.3-4.1,3-5.7,5.1c-1.5,2.1-2.7,4.5-3.5,7.2c-0.8,2.7-1.2,5.4-1.2,8.3 c0,3,0.4,5.8,1.3,8.4c0.9,2.6,2.1,4.9,3.7,6.8c1.6,1.9,3.5,3.5,5.7,4.6s4.7,1.7,7.5,1.7c2.2,0,4.2-0.4,6.1-1.2 c1.9-0.8,3.6-1.8,5.1-3.1c1.5-1.3,2.7-2.8,3.7-4.5c1-1.7,1.7-3.4,2.1-5.2h0.7l-0.2,13.7h-0.8c-0.5-0.7-1-1.4-1.6-1.9 c-0.5-0.6-0.9-0.9-1.1-0.9c-0.1,0-0.5,0.2-1.1,0.7c-0.7,0.4-1.6,0.9-2.9,1.4s-2.8,1-4.6,1.4c-1.8,0.4-3.9,0.6-6.2,0.6 c-3.9,0-7.4-0.6-10.5-1.7c-3.1-1.1-5.8-2.7-8-4.7c-2.2-2-3.9-4.4-5-7.2c-1.2-2.8-1.7-5.9-1.7-9.3c0-0.7,0.1-1.6,0.2-2.6 c0.1-1,0.3-2,0.6-3.1c0.3-1.1,0.6-2.2,1.1-3.4s1.1-2.4,1.8-3.6c0.9-1.4,2-2.8,3.2-4.1c1.3-1.3,2.8-2.4,4.6-3.4 c1.7-1,3.7-1.8,5.9-2.3c2.2-0.6,4.7-0.9,7.4-0.9c2.5,0,4.7,0.2,6.6,0.7s3.4,1,4.7,1.5c1.2,0.5,2.2,1,2.9,1.5 c0.7,0.5,1,0.7,1.1,0.7c0.1,0,0.2-0.1,0.5-0.3c0.2-0.2,0.5-0.4,0.7-0.7c0.3-0.3,0.6-0.6,0.8-0.9c0.3-0.4,0.6-0.7,0.8-1.1h0.7v14 L459.5,778.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.4,765.5c-0.9,0.6-1.6,1.5-2.1,2.7c-0.1,0.3-0.2,0.8-0.3,1.4c-0.1,0.7-0.2,1.4-0.3,2.3 c-0.1,0.9-0.1,1.8-0.2,2.8c0,1-0.1,1.9-0.1,2.9c0,1.8-0.1,3.8-0.2,6c-0.1,2.2-0.1,4.7-0.2,7.5c0,0.8-0.1,1.8-0.2,3 c-0.1,1.2-0.3,2.5-0.6,3.8c-0.3,1.4-0.9,2.7-1.6,4.1c-0.7,1.4-1.8,2.6-3.1,3.7c-1.3,1.1-3,2-5.1,2.6c-2.1,0.6-4.6,1-7.7,1 c-3,0-5.5-0.3-7.6-0.9c-2.1-0.6-3.8-1.5-5.1-2.5c-1.3-1.1-2.4-2.2-3.1-3.5c-0.7-1.3-1.3-2.5-1.6-3.7c-0.4-1.2-0.6-2.4-0.6-3.4 c-0.1-1-0.1-1.8-0.1-2.3c0-1.2,0-2.7,0-4.6c0-1.9,0-4,0-6.2v-8.3c0-0.8,0-1.5,0-2.2c0-0.8,0-1.4-0.1-2.1c-0.1-0.6-0.2-1.2-0.3-1.7 c-0.1-0.5-0.3-0.9-0.6-1.2c-0.6-0.7-1.3-1.2-2.2-1.5c-0.9-0.3-1.8-0.5-2.9-0.7v-0.6h18.6v0.6c-0.6,0.1-1.2,0.2-1.9,0.4 c-0.7,0.2-1.3,0.4-1.8,0.8c-0.5,0.4-1,0.8-1.4,1.5c-0.4,0.6-0.6,1.4-0.6,2.4c0,1.1-0.1,2-0.1,2.9c0,0.8,0,1.6,0,2.4 c0,0.8,0,1.6,0,2.5c0,0.8,0,1.8,0,2.9c0,1.4,0,2.7,0,3.8s0,2.2,0,3.2c0,1,0,1.9,0,2.8c0,0.9,0,1.8,0,2.8c0,2.2,0.4,4.2,1,6 c0.6,1.8,1.5,3.4,2.6,4.6c1.1,1.3,2.5,2.2,4.1,2.9c1.6,0.7,3.5,1,5.6,1c2.4,0,4.4-0.3,6-0.8c1.6-0.5,3-1.3,4.1-2.2 c1.1-1,2-2.1,2.6-3.3s1.1-2.6,1.4-4c0.3-1.4,0.5-2.9,0.6-4.3c0.1-1.5,0.2-2.9,0.2-4.3c0-1.1,0-2.1,0-3.1s0-1.8,0-2.6 c0-0.8,0-1.6,0-2.4c0-0.8,0-1.7,0-2.6c0-0.8,0-1.7,0-2.6c0-0.9-0.1-1.7-0.1-2.5c0-0.8-0.1-1.5-0.2-2.2c-0.1-0.7-0.2-1.2-0.4-1.7 c-0.4-1.2-1.1-2.1-2.2-2.8c-1-0.7-2.5-1.2-4.5-1.5v-0.6h15.5v0.6C512.5,764.5,511.3,764.9,510.4,765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M562.1,798.7c-1.2,2.3-2.8,4.2-4.8,5.8s-4.5,2.8-7.4,3.6s-6,1.2-9.4,1.2c-2.9,0-5.4-0.2-7.5-0.5 c-2.1-0.4-3.8-0.8-5.2-1.3c-1.4-0.5-2.4-1-3.1-1.4c-0.7-0.4-1.1-0.6-1.3-0.6c-0.2,0-0.6,0.4-1.2,1.1c-0.6,0.7-1.1,1.4-1.6,2.1H520 l-0.3-17.8h0.9c0.5,1.6,1.2,3.2,2.1,4.7c0.8,1.5,1.7,2.9,2.7,4.3c1,1.3,2,2.5,3.1,3.5c1.1,1,2.2,1.8,3.2,2.3c1,0.5,2.3,1.1,4,1.6 c1.7,0.5,3.3,0.8,4.8,0.8c4.4,0,8-1.2,10.7-3.6c2.7-2.4,4.1-5.7,4.1-9.8c0-1.7-0.3-3.1-0.8-4.4s-1.3-2.3-2.2-3.3 c-0.9-0.9-2-1.7-3.3-2.4c-1.2-0.7-2.6-1.2-4-1.8c-1.4-0.5-2.7-1-3.7-1.3c-1.1-0.4-2.1-0.7-3-1c-0.9-0.3-1.9-0.7-2.9-1 c-1-0.3-2.2-0.8-3.5-1.3c-1.5-0.6-3-1.4-4.5-2.5c-1.4-1-2.7-2.3-3.7-3.7c-1.1-1.4-1.9-2.9-2.6-4.6c-0.7-1.7-1-3.5-1-5.4 c0-3.2,0.6-6,1.8-8.3s2.7-4.3,4.7-5.8c2-1.5,4.3-2.7,6.8-3.4c2.6-0.7,5.3-1.1,8.2-1.1c2.7,0,5,0.2,6.9,0.7s3.5,0.9,4.7,1.5 c1.2,0.5,2.1,1,2.8,1.5c0.6,0.4,1,0.7,1,0.7c0.2,0,0.5-0.4,1.1-1.1c0.6-0.7,1.1-1.4,1.6-2.1h1V761h-1c-0.7-2-1.6-3.9-2.8-5.8 s-2.4-3.7-3.9-5.2c-1.5-1.5-3.2-2.8-5.1-3.7c-1.9-1-4-1.4-6.3-1.4c-1.8,0-3.6,0.3-5.2,0.8c-1.6,0.5-3.1,1.3-4.3,2.4 c-1.2,1.1-2.2,2.4-2.9,4c-0.7,1.6-1,3.4-1,5.4c0,3.2,0.9,5.7,2.8,7.6c1.9,1.9,4.4,3.4,7.4,4.5c1.2,0.5,2.3,0.9,3.3,1.2 c1,0.4,2.1,0.7,3.1,1c1,0.3,2,0.7,3.1,1c1,0.4,2.1,0.7,3.2,1.2c4,1.5,7.2,3.6,9.4,6.5c2.2,2.8,3.3,6.3,3.3,10.6 C563.9,793.9,563.3,796.4,562.1,798.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M606.8,765.1c-0.8,0.4-1.6,1-2.3,1.6c-0.7,0.7-1.4,1.5-2,2.4s-1.3,2-2.1,3.1c-0.5,0.8-1.2,1.9-2.1,3.2 c-0.9,1.4-1.8,2.8-2.7,4.2c-0.9,1.5-1.8,2.9-2.7,4.2c-0.9,1.3-1.6,2.4-2.1,3.1v12.6c0,1.2,0,2.4,0.1,3.5c0.1,1.1,0.3,1.9,0.6,2.4 c0.6,0.9,1.4,1.5,2.4,1.8c1,0.3,2,0.5,2.9,0.7v0.6h-19.2V808c1.1-0.1,2-0.3,2.8-0.6c0.8-0.3,1.7-0.9,2.6-2 c0.2-0.2,0.4-0.6,0.5-1.1c0.1-0.5,0.2-1.1,0.2-1.7c0.1-0.6,0.1-1.3,0.1-2c0-0.7,0-1.4,0-2.1c0-1.2,0.1-2.5,0.1-4.2 c0-1.6,0-3.5,0-5.8c-0.1-0.1-0.3-0.5-0.8-1.2s-0.9-1.5-1.5-2.5c-0.6-1-1.3-2.1-2-3.3c-0.7-1.2-1.4-2.4-2.2-3.5 c-0.7-1.1-1.4-2.2-2-3.2c-0.6-1-1.1-1.8-1.6-2.4c-0.8-1.2-1.5-2.3-2.2-3.3c-0.6-1-1.3-1.9-2-2.6c-0.7-0.7-1.3-1.3-2-1.7 c-0.6-0.4-1.4-0.6-2.2-0.7v-0.6h18.9v0.6c-0.6,0-1.2,0.1-1.9,0.2c-0.6,0.1-1.2,0.2-1.7,0.4c-0.5,0.2-1,0.4-1.3,0.8 c-0.3,0.3-0.5,0.7-0.5,1.3s0.3,1.4,0.9,2.5c0.6,1.1,1.2,2.2,1.9,3.3c0.5,0.7,1,1.7,1.6,2.7c0.6,1.1,1.3,2.2,2.1,3.4 s1.5,2.4,2.3,3.7c0.8,1.2,1.5,2.4,2.2,3.6c0.5-0.8,1.2-1.8,2-3s1.6-2.5,2.4-3.7c0.8-1.3,1.6-2.5,2.3-3.7c0.7-1.2,1.3-2.1,1.7-2.7 c0.2-0.3,0.4-0.7,0.7-1.2c0.2-0.4,0.5-0.9,0.7-1.4c0.2-0.5,0.4-1,0.6-1.5c0.2-0.5,0.2-1,0.2-1.4c0-0.7-0.2-1.2-0.5-1.6 c-0.3-0.4-0.8-0.7-1.3-0.9c-0.5-0.2-1.1-0.4-1.7-0.5c-0.6-0.1-1.2-0.2-1.8-0.3v-0.6h14.4v0.6C608.6,764.4,607.6,764.7,606.8,765.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M656.2,765.5c-0.9,0.6-1.7,1.5-2.2,2.7c-0.3,0.6-0.5,1.8-0.6,3.5c-0.1,1.7-0.2,3.5-0.2,5.4 c-0.1,1.8-0.2,3.9-0.2,6.3s-0.1,5-0.1,7.8c0,1.2,0,2.5,0,4c0,1.5,0,2.9,0,4.5c0,1.5,0,3,0,4.5s0,2.9,0,4.1c0,0.2-0.1,0.3-0.2,0.4 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.3,0-0.7-0.2-1.1-0.6c-3.5-4.1-6.8-7.8-9.7-11.2c-2.9-3.4-5.7-6.7-8.3-9.8c-2.6-3.1-5.2-6.1-7.8-9.1 c-2.5-3-5.2-6-8.1-9.2v26.4c0,2.1,0.1,4,0.2,5.7c0.1,1.7,0.4,3,0.8,3.8c0.5,1,1.2,1.7,2.2,2.2c1,0.5,2.3,0.8,4,1v0.6h-15.4V808 c1-0.1,2-0.4,3-0.8c1-0.4,1.8-1.1,2.4-2c0.6-0.9,1-2.2,1.1-3.9c0.2-1.7,0.3-3.7,0.4-6.1c0.1-1.8,0.1-3.9,0.2-6.3 c0-2.4,0.1-5,0.1-7.8c0-1.2,0-2.2,0-3c0-0.8,0-1.6,0-2.3s0-1.5,0-2.3c0-0.8,0-1.9-0.1-3.1c-0.1-1.2-0.4-2.2-0.9-3 c-0.5-0.8-1-1.4-1.6-1.8c-0.6-0.4-1.3-0.8-2-0.9c-0.7-0.2-1.4-0.3-2.1-0.4v-0.6h12.7l29.6,34.6V777c0-1.7,0-3.3-0.1-4.8 c0-1.5-0.2-2.7-0.6-3.6c-0.4-1.2-1.2-2.1-2.2-2.8s-2.6-1.2-4.6-1.5v-0.6h15.5v0.6C658.4,764.5,657.1,764.9,656.2,765.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M705.7,778.1c-0.5-2-1.4-3.9-2.4-5.6c-1.1-1.7-2.4-3.3-3.8-4.6c-1.5-1.3-3.1-2.3-5-3.1 c-1.9-0.7-3.8-1.1-5.9-1.1c-2.9,0-5.4,0.6-7.7,1.9c-2.2,1.3-4.1,3-5.7,5.1s-2.7,4.5-3.5,7.2c-0.8,2.7-1.2,5.4-1.2,8.3 c0,3,0.4,5.8,1.3,8.4s2.1,4.9,3.7,6.8s3.5,3.5,5.7,4.6s4.7,1.7,7.5,1.7c2.2,0,4.2-0.4,6.1-1.2s3.6-1.8,5.1-3.1 c1.5-1.3,2.7-2.8,3.7-4.5c1-1.7,1.7-3.4,2.1-5.2h0.7l-0.2,13.7h-0.7c-0.5-0.7-1-1.4-1.6-1.9s-0.9-0.9-1.1-0.9 c-0.1,0-0.5,0.2-1.1,0.7c-0.7,0.4-1.6,0.9-2.9,1.4s-2.8,1-4.6,1.4c-1.8,0.4-3.9,0.6-6.2,0.6c-3.9,0-7.4-0.6-10.5-1.7 c-3.1-1.1-5.8-2.7-8-4.7c-2.2-2-3.9-4.4-5-7.2c-1.2-2.8-1.7-5.9-1.7-9.3c0-0.7,0.1-1.6,0.2-2.6c0.1-1,0.3-2,0.6-3.1 c0.3-1.1,0.6-2.2,1.1-3.4c0.5-1.2,1.1-2.4,1.8-3.6c0.9-1.4,2-2.8,3.2-4.1c1.3-1.3,2.8-2.4,4.6-3.4c1.7-1,3.7-1.8,5.9-2.3 c2.2-0.6,4.7-0.9,7.4-0.9c2.5,0,4.7,0.2,6.6,0.7s3.4,1,4.7,1.5c1.2,0.5,2.2,1,2.9,1.5c0.7,0.5,1,0.7,1.1,0.7 c0.1,0,0.2-0.1,0.5-0.3c0.2-0.2,0.5-0.4,0.7-0.7c0.3-0.3,0.6-0.6,0.8-0.9c0.3-0.4,0.6-0.7,0.8-1.1h0.7v14L705.7,778.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter",
    filterUnits: "userSpaceOnUse",
    x: 364.7,
    y: 693.9,
    width: 304.9,
    height: 23.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend || (_feBlend = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 364.7,
    y: 693.9,
    width: 304.9,
    height: 23.7,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Adobe_OpacityMaskFilter_00000109015046280527361620000015059019619850500480_",
    filterUnits: "userSpaceOnUse",
    x: 364.7,
    y: 693.9,
    width: 304.9,
    height: 23.7
  }, /*#__PURE__*/React.createElement("feFlood", {
    style: {
      floodColor: "white",
      floodOpacity: 1
    },
    result: "back"
  }), _feBlend2 || (_feBlend2 = /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "back",
    mode: "normal"
  })))), /*#__PURE__*/React.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: 364.7,
    y: 693.9,
    width: 304.9,
    height: 23.7,
    id: "SVGID_1_"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      filter: "url(#Adobe_OpacityMaskFilter_00000109015046280527361620000015059019619850500480_)"
    }
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000171698098498580749510000012278355699700063617_",
    cx: 517.1655,
    cy: 52537.6523,
    r: 148.9417,
    gradientTransform: "matrix(1 0 0 7.370000e-02 0 -3166.2336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1449,
    style: {
      stopColor: "#D4D4D4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4609,
    style: {
      stopColor: "#7A7A7A"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7184,
    style: {
      stopColor: "#383838"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9043,
    style: {
      stopColor: "#101010"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      mask: "url(#SVGID_1_)",
      fill: "url(#SVGID_00000171698098498580749510000012278355699700063617_)"
    },
    cx: 517.2,
    cy: 705.8,
    rx: 152.5,
    ry: 11.8
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000174603989259608001140000010604159412748771492_",
    cx: 517.1655,
    cy: 52537.6523,
    r: 148.9417,
    gradientTransform: "matrix(1 0 0 7.370000e-02 0 -3166.2336)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#000000"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3399,
    style: {
      stopColor: "#1E2736",
      stopOpacity: 0.6601
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6551,
    style: {
      stopColor: "#223758",
      stopOpacity: 0.3449
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8827,
    style: {
      stopColor: "#1D3F6E",
      stopOpacity: 0.1173
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A4277",
      stopOpacity: 0
    }
  })), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      opacity: 0.46,
      fill: "url(#SVGID_00000174603989259608001140000010604159412748771492_)"
    },
    cx: 517.2,
    cy: 705.8,
    rx: 152.5,
    ry: 11.8
  }), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M351.1,292.9l19.3,75.4c0,0,93.7-118.1,246.3-121.7l-113.3-3.2c0,0,79-5.7,82.3-5.8l-74.9-43.3L302.3,314.6 c0,0,1.4,45.4,8.1,84.7C317.4,375,334.8,324.2,351.1,292.9z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000031188859168142369500000000571697682000205977_",
    cx: 522.2902,
    cy: 428.5718,
    r: 236.1211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ED1C24"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0344426,
    style: {
      stopColor: "#E51B23"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.218,
    style: {
      stopColor: "#CB1721"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4054,
    style: {
      stopColor: "#B7121E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.596,
    style: {
      stopColor: "#A90D1B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7916,
    style: {
      stopColor: "#A00A18"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#9E0918"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000031188859168142369500000000571697682000205977_)"
    },
    d: "M370.3,542 c11.3,17.8,24.4,35.4,39.8,52.5c21-4.5,17.6-8.2,17.6-8.2l-4.5,14.9c63.9-7.4,246.4-65.1,239.5-153.7l20,38.4 c14.1-32.4,22.6-65.1,28.1-91.4c0.3-1.5,4.5-24.7,6.6-41c2.8-24.1,2.4-38.8,2.4-38.8l-94.3-54.4c-22,4.4-21.4,9-21.4,9l5.3-13.2 c-63.9,7.4-245.3,61.6-238.2,151.5l-19.6-40.6c0,0-26,34.5-28.9,73.4c8.2,25.7,20.9,55.4,36.6,83.3 C363.8,531.5,369.2,540.3,370.3,542z"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M668.1,481.8c0,0-88.3,125.7-244.9,126.9l109.8,16.6c0,0-84.8-5.5-97.6-6.2c22.2,20.8,45.8,38.7,76.1,56 c77.4-44.5,128-105.9,158.7-163.6L668.1,481.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M302.3,314.6c0,0,122.9,285.2,303.1,286.5c-36.8,39.8-83.5,68.7-94,73.9c0,0-34.8-17-76.1-56l97.6,6.2 l-106.4-15.9c-25.3-18.8-67.6-73.3-95.3-144.8C314,420,304.3,370.2,302.3,314.6z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M427.7,242.3c0,0,276.9,42.8,271.3,197.8c0,0,19.7-59.4,20.9-125.4l-119.2-68.3l-97.3-2.9l82.4-5.9l-75-43.2 L427.7,242.3z"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000123427411853486604860000000803610606482107267_",
    cx: 505.3491,
    cy: 388.0391,
    r: 315.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBB040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9ED32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000122684035817003520750000013881859497772189854_",
    style: {
      fill: "url(#XMLID_00000123427411853486604860000000803610606482107267_)"
    },
    d: " M353.9,513.1c-66.1-56.8-2.7-143.2-2.7-143.2l33.9,102.8C378,382.8,544.8,263.4,608.8,256l-25.6,35.3c0,0,44.9-43,99.7-28 c-42-30.8-112.6-44.2-112.6-44.2l37.2,27.3c-156.6,1.2-230.7,108.7-230.7,108.7l-25.7-79.8c-82.5,158.4-71.1,225.6,19.7,267 C370.8,542.3,357.8,521.4,353.9,513.1z"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "XMLID_00000043435332827719990940000013370652752797647239_",
    cx: 505.3491,
    cy: 388.0391,
    r: 315.7603,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FBB040"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#F9ED32"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_00000142157032770457787350000014611599736543146658_",
    style: {
      fill: "url(#XMLID_00000043435332827719990940000013370652752797647239_)"
    },
    d: " M710.2,394.6c6.1,46.4-27.4,91.3-27.4,91.3l-23.9-110.8c7.1,89.9-169.7,217.4-233.6,224.8l29.3-39.6c0,0-48.6,47.2-103.4,32.2 c42,30.8,100.3,53,100.3,53l-24.9-36.1c156.6-1.2,236.8-120.8,236.8-120.8l17.1,80.2c54.8-105.2,62.6-177.9,36.5-215.5 C714.7,370.2,710.2,394.6,710.2,394.6z"
  }), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M457.7,408.5l35.5,92.4c0,0,37.2-125.2,140.5-153.3c0,0-88,1.5-139.5,101.6 C494.2,449.3,489.4,435.8,457.7,408.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M457.7,408.5c26.2,25.1,36.8,51.6,36.8,51.6s29.4-94.1,139.2-112.4c0,0-88,1.5-139.5,101.6 C494.2,449.3,484,427.7,457.7,408.5z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M583.2,291.3c0,0,45.2-43.1,99.7-28c0,0-30.9-15.6-77.7,5.8l13-18.5c0,0-202.4,21.9-236.8,197.8 c-2-7.1-31.6-111.8-31.6-111.8s-86.8,133.1,9.6,186.9l-5.4-10.5c0,0-65.9-43.9-2.7-143.2l33.9,102.8 c1.7-55,61-155.6,223.7-216.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M454.5,560.3c0,0-44.2,40.9-103.4,32.2c0,0,33.2,18.4,80-3.1l-15.2,19.3c0,0,197.6-53.8,240.2-194.7 c2,7.1,22.8,100.4,22.8,100.4s45.8-57,33.9-133.6l-3.2,18.6c0,0,4.7,45.2-26.8,86.6l-23.9-110.8c-1.7,55-70.9,163.6-233.6,224.8 "
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M375.7,372.6l8,33.8c0,0-10.9-82.4,172.2-150.4C555.9,256,440.3,272.7,375.7,372.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M600.2,230.5c0,0,43.5,15.4,63.1,24.1c0,0-18.3-6-38.1-1.6l14.9-5.3L600.2,230.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M663.3,479l-6.6-38.9c0,0,6.6,83.5-181.9,159.7C474.8,599.8,587.2,572.7,663.3,479z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M430.5,625.2c0,0-43.5-15.4-63.1-24.1c0,0,18.3,6,38.1,1.6l-14.9,5.3L430.5,625.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M359.2,523.6l7.5,12.5c0,0-115.2-39.6-17-199.4C265.6,482.9,359.2,523.6,359.2,523.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M678.9,514.4c0,0,44.2-50.5,33.9-133.6l2-14.9C714.8,365.8,738.8,441.9,678.9,514.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000117659858970058442620000015426021358182205319_",
    cx: 389.472,
    cy: 291.674,
    r: 12.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000117659858970058442620000015426021358182205319_)"
    },
    points: "389.5,279.3 392.7,288.6  402.5,288.8 394.7,294.7 397.5,304 389.5,298.4 381.4,304 384.3,294.7 376.5,288.8 386.3,288.6  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000095298665774829708440000017405471119835306429_",
    cx: 420.3148,
    cy: 274.553,
    r: 12.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000095298665774829708440000017405471119835306429_)"
    },
    points: "420.3,262.2 423.5,271.5  433.3,271.6 425.5,277.5 428.3,286.9 420.3,281.3 412.3,286.9 415.1,277.5 407.3,271.6 417.1,271.5  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000004510961003616256580000010684926270333855628_",
    cx: 451.3036,
    cy: 257.4348,
    r: 12.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000004510961003616256580000010684926270333855628_)"
    },
    points: "451.3,245.1 454.5,254.3  464.3,254.5 456.5,260.4 459.3,269.8 451.3,264.2 443.3,269.8 446.1,260.4 438.3,254.5 448.1,254.3  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000109736117616234940080000002861797275296883131_",
    cx: 479.699,
    cy: 241.7698,
    r: 12.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000109736117616234940080000002861797275296883131_)"
    },
    points: "479.7,229.4 482.9,238.7  492.7,238.9 484.9,244.8 487.7,254.1 479.7,248.5 471.7,254.1 474.5,244.8 466.7,238.9 476.5,238.7  "
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000067958284852708098130000012429765125237047982_",
    cx: 509.4431,
    cy: 226.0234,
    r: 12.6862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFF200"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FBB040"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000067958284852708098130000012429765125237047982_)"
    },
    points: "509.4,213.7 512.6,222.9  522.4,223.1 514.6,229 517.5,238.4 509.4,232.8 501.4,238.4 504.3,229 496.4,223.1 506.2,222.9  "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M499.8,679.7l-35.4-22.8c-113.2-20.7-250-101.4-168.3-275.8C296.1,381,152.6,647.3,499.8,679.7z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M542.2,204.7c0,0,205.7-0.4,189.1,142.9c0,0,37.9-153.1-214.1-156.9L542.2,204.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M483.8,669.7l-19.4-12.8c-113.2-20.7-250-101.4-168.3-275.8C296.1,381,164.5,625.2,483.8,669.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M542.2,204.7c0,0,205.7-0.4,189.1,142.9c0,0,30-145.7-201.6-149.9L542.2,204.7z"
  })))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M500,736.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocusyncLogo);
export default __webpack_public_path__ + "static/media/Docusync-logo.9a93a9ab9a584bf43305ba1d0239290a.svg";
export { ForwardRef as ReactComponent };